import { clTransform } from 'app/utils/cloudinaryUtils'
import React from 'react'
import styled from 'styled-components'

// For clip relative svg is needed, use https://yoksel.github.io/relative-clip-path/ for conversion

export type ClipperWaveVariant = 'curva-semplice-verso-alto'

export type ClipperBgPosition = 'top' | 'bottom' | 'center'

type Props = {
  bgImage?: string
  bgSize?: 'cover' | 'contain'
  bgColor?: string
  bgPosition?: string
  bgDesktop?: string
  bgHeight?: number
  waveVariant?: ClipperWaveVariant
  className?: string
}

export const Clipper = ({
  bgImage,
  bgSize,
  bgColor,
  bgPosition,
  bgDesktop,
  bgHeight,
  waveVariant = 'curva-semplice-verso-alto',
  className,
  children,
}: WithChildren<Props>): JSX.Element => {
  return (
    <div className={className}>
      <Path>
        <clipPath
          id='curva-semplice-verso-alto'
          clipPathUnits='objectBoundingBox'
        >
          <path
            className='wave-lg'
            d='M0,0 V1 c0.083,-0.012,0.181,-0.027,0.292,-0.036 c0.067,-0.006,0.139,-0.01,0.216,-0.01 c0.05,0,0.122,0.001,0.201,0.004 c0.094,0.003,0.199,0.008,0.292,0.015 V0'
          ></path>
          <path
            className='wave-xs'
            d='M0,0 V1 C0.147,0.985,0.318,0.97,0.51,0.97 c0.112,0,0.305,0.004,0.49,0.012 V0'
          ></path>
        </clipPath>
      </Path>

      <Clip waveVariant={waveVariant}>
        <BackgroundWrapper
          bgImage={clTransform({ url: bgImage || '' })}
          bgSize={bgSize}
          bgColor={bgColor}
          bgPosition={bgPosition}
          bgDesktop={bgDesktop}
          bgHeight={bgHeight}
        >
          {children}
        </BackgroundWrapper>
      </Clip>
    </div>
  )
}

const Path = styled.svg`
  position: absolute;
  width: 0;
  height: 0;

  .wave-lg {
    display: none;
    @media (min-width: ${({ theme }) => theme.bp.desktop}) {
      display: block;
    }
  }

  .wave-xs {
    @media (min-width: ${({ theme }) => theme.bp.desktop}) {
      display: none;
    }
  }
`

type ClipProps = {
  waveVariant: ClipperWaveVariant
}

const Clip = styled.div<ClipProps>`
  clip-path: url('#${({ waveVariant }) => waveVariant}');
`

const BackgroundWrapper = styled.div<Partial<Props>>`
  background-image: url(${({ bgImage }) => bgImage});
  background-size: ${({ bgSize }) => bgSize};
  background-position: ${({ bgPosition }) => bgPosition || 'top center'};
  background: ${({ bgColor }) => bgColor};
  background-repeat: no-repeat;
  height: ${({ bgHeight }) => bgHeight}px;
  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    background: ${({ bgDesktop }) => bgDesktop};
  }
`
